export enum CashbackCurrency {
  TOTAL_REVENUE_EURO = "TOTAL_REVENUE_EURO",
}
